// src/components/PageHeader/PageHeader.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './PageHeader.module.css';
import { FiArrowLeft } from 'react-icons/fi';

// 1. Adicionamos 'children' à lista de props
const PageHeader = ({ title, subtitle, backTo = "/", children }) => {
  return (
    <header className={`${styles.header} ${children ? styles.withActions : ''}`}>
      <Link to={backTo} className={styles.backLink}>
        <FiArrowLeft />
      </Link>
      <div className={styles.headerContent}>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      
      {/* 2. Criamos uma área para renderizar os 'children' se eles existirem */}
      {children && (
        <div className={styles.headerActions}>
          {children}
        </div>
      )}
    </header>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  backTo: PropTypes.string,
  // 3. Adicionamos a validação para 'children'
  children: PropTypes.node, // 'node' significa qualquer coisa que o React pode renderizar
};

export default PageHeader;